import styled from 'styled-components';

export const SelectedViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  /* height: 100%; */
`;

export const InnerDataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h4 {
    font-size: 18px;
    font-weight: bold;
    opacity: 0.9;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;

    img {
      width: 18px;
    }
  }

  /* div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  } */

  strong {
    margin-right: 2px;
    font-weight: bold;
    opacity: 1;
    font-size: 15px;
  }

  > small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        font-size: 11px;
        width: 100%;
        text-align: center;
        margin-top: 8px;
  }

  small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
  }

  small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
    }

  small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
  }

  small.red {
        background: ${({ theme }) => theme.colors.danger.light};
        color: ${({ theme }) => theme.colors.danger.dark};
  }

  > div.workplacesContainer {
    max-height: 220px;
    overflow-y: auto;

    > div.workplaceInfoContainer {
      display: flex;
      flex-direction: row;
      align-items: center;

      > small {
          background: ${({ theme }) => theme.colors.blue[50]};
          color: ${({ theme }) => theme.colors.blue[900]};
          font-weight: bold;
          text-transform: uppercase;
          padding: 4px;
          border-radius: 4px;
          font-size: 11px;
          width: 100%;
          text-align: center;
          margin-top: 8px;
    }
    }
  }
`;


export const Card = styled.div`
  padding: 24px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 16px;
  box-shadow: 0 0.125rem 0.375rem 0 rgb(161 172 184 / 12%);

  & + & {
    margin-top: 16px;
  }
`;

export const RangeSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  bottom: 10px;
  gap: 4px;

  .range-slider {
      width: 100%;
      .range-slider__range {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .range-slider__thumb {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .single-thumb {
        width: 0;
      }
      .range-slider__thumb[data-lower] {
        width: 0;
      }
      .range-slider__range {
        border-radius: 6px;
      }
    }

  @media(max-width: 500px) {
      width: 50%;
      margin-top: 8px;
    }
  header {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 700;
  }
`;
